import React from 'react';
import { safeToLocaleString } from '../../utils/safeAccess';

/**
 * DashboardStatsOverview
 *
 * Props:
 * - assessmentsLoading: boolean indicates if assessments are still loading
 * - stats: object with total_assessments, total_recommendations, total_savings, avg_payback
 */
const DashboardStatsOverview = ({ assessmentsLoading, stats }) => {
  if (assessmentsLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md animate-pulse"
          >
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-3" />
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-l-4 border-blue-500 dark:border-blue-600">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
          Total Assessments
        </h3>
        <p className="text-3xl font-bold text-blue-600 dark:text-blue-400">
          {safeToLocaleString(stats?.total_assessments)}
        </p>
      </div>
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-l-4 border-green-500 dark:border-green-600">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
          Total Recommendations
        </h3>
        <p className="text-3xl font-bold text-green-600 dark:text-green-400">
          {safeToLocaleString(stats?.total_recommendations)}
        </p>
      </div>
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-l-4 border-purple-500 dark:border-purple-600">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
          Total Savings
        </h3>
        <p className="text-3xl font-bold text-purple-600 dark:text-purple-400">
          ${Math.round(stats?.total_savings || 0).toLocaleString()}
        </p>
      </div>
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md border-l-4 border-orange-500 dark:border-orange-600">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
          Avg Payback
        </h3>
        <p className="text-3xl font-bold text-orange-600 dark:text-orange-400">
          {(stats?.avg_payback || 0).toFixed(1)} yrs
        </p>
      </div>
    </div>
  );
};

export default DashboardStatsOverview;


